// What each model actually produces, confirmed against bp-back's
// inference_service.py (all four models run through one process, dispatched
// by model_name — see scripts/inference_service.py and the per-model
// BaseBPFormer.py / DeepPhys / PhysFormer handlers).
//
// RhythmNet is the only model with a real, learned BP waveform/ICG/SpO2.
// BaseBPFormer, DeepPhys, and PhysFormer ("SeeVita v1/v2/v3") share the same
// shape: HR/HRV/RR are real model output, SBP/DBP are either a real but
// narrower BP estimate (v1) or a linear formula off HR (v2/v3) — none of the
// three produce MAP or SpO2 at all. Their "ECG" is entirely synthetic
// (neurokit2.ecg_simulate seeded from HR, not measured), so it's treated as
// absent here rather than shown as a real signal.
export interface ModelCapabilities {
  vitals: {
    heartRate: boolean;
    systolicBP: boolean;
    diastolicBP: boolean;
    map: boolean;
    respiratoryRate: boolean;
    spo2: boolean;
    hrv: boolean;
  };
  waveforms: {
    ppg: boolean;
    ecg: boolean;
    icg: boolean;
    bp: boolean;
  };
}

const RHYTHMNET_CAPABILITIES: ModelCapabilities = {
  vitals: { heartRate: true, systolicBP: true, diastolicBP: true, map: true, respiratoryRate: true, spo2: true, hrv: true },
  waveforms: { ppg: true, ecg: true, icg: true, bp: true },
};

const LEGACY_CAPABILITIES: ModelCapabilities = {
  vitals: { heartRate: true, systolicBP: true, diastolicBP: true, map: false, respiratoryRate: true, spo2: false, hrv: true },
  waveforms: { ppg: true, ecg: false, icg: false, bp: false },
};

export function getModelCapabilities(modelId: string | undefined | null): ModelCapabilities {
  const id = (modelId ?? '').toLowerCase();
  if (id.includes('rhythmnet')) return RHYTHMNET_CAPABILITIES;
  if (id.includes('deepphys') || id.includes('physformer') || id.includes('bpformer')) return LEGACY_CAPABILITIES;
  // Unrecognized id (new model, or none selected yet) — default to the full
  // set rather than hiding everything for a model we just don't know yet.
  return RHYTHMNET_CAPABILITIES;
}
